import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, of} from 'rxjs';

import * as EmployeeModels from '@employee-models/index';
import {catchError, map} from 'rxjs/operators';
import {API_CONFIG} from '@shared-models/common.models';
import {ICroppPhotoRequestBulk} from '@employee-models/data.models';

let ApiConfig;
function generateParams(params: EmployeeModels.CM.IActionParams): string {
    return Object.keys(params).map(key => key + '=' + params[key]).join('&');
}

@Injectable()
export class PhotoReviewService {

    constructor(private httpClient: HttpClient,
                @Optional() @Inject(API_CONFIG) public apiConfig: string,
                ) {
                    ApiConfig = apiConfig;
                }

    getPhotoReviewGrid(
        requestParams: EmployeeModels.DM.IGridRequest
    ): Observable<EmployeeModels.DM.IPhotoReviewGridResponse | { error: HttpErrorResponse }> {
        return this.httpClient.post<EmployeeModels.DM.IPhotoReviewGridResponse>(ApiConfig.PhotoReview.getPhotoReviewGrid, requestParams)
            .pipe(catchError(error => of({ error })));
    }

    approvePhoto(params: EmployeeModels.CM.IActionParams): Observable<{} | { error: HttpErrorResponse }> {
        return this.httpClient.post(`${ApiConfig.PhotoReview.approvePhoto}?${generateParams(params)}`, null)
            .pipe(
                map(() => of({})),
                catchError(error => of({ error }))
            );
    }

    declinePhoto(payload: EmployeeModels.DM.IRejectedPhotoReasonRequest): Observable<{} | { error: HttpErrorResponse }> {
        return this.httpClient.post(`${ApiConfig.PhotoReview.declinePhoto}`, payload)
            .pipe(
                map(() => of({})),
                catchError(error => of({ error }))
            );
    }

    resubmissionPending(params: EmployeeModels.CM.IActionParams): Observable<{}> {
        return this.httpClient.post(`${ApiConfig.PhotoReview.resubmissionPending}?${generateParams(params)}`, null)
            .pipe(catchError(error => of({ error })));
    }

    furtherReviewPhoto(params: EmployeeModels.CM.IActionParams): Observable<{} | { error: HttpErrorResponse }> {
        return this.httpClient.post(`${ApiConfig.PhotoReview.furtherReviewPhoto}?${generateParams(params)}`, null)
            .pipe(
                map(() => of({})),
                catchError(error => of({ error }))
            );
    }

    bulkChangeSite(
        request: EmployeeModels.DM.IBulkChangeSiteRequest
    ): Observable<EmployeeModels.DM.IBulkChangeStatusResponse & { error: HttpErrorResponse }> {
        return this.httpClient.post(`${ApiConfig.PhotoReview.bulkChangeSite}`, request)
            .pipe(
                catchError(error => of({error}))
            ) as Observable<EmployeeModels.DM.IBulkChangeStatusResponse & { error: HttpErrorResponse }>;
    }

    getSitesForBulkChangeSite(
        request: EmployeeModels.DM.IBulkSelectSiteRequest
    ): Observable<EmployeeModels.DM.IDeliveryLocationDto[]> {
        return this.httpClient.post<EmployeeModels.DM.IDeliveryLocationDto[]>(ApiConfig.PhotoReview.getSitesForBulkChangeSite, request);
    }

    bulkCroppPhoto(request: ICroppPhotoRequestBulk): Observable<unknown> {
        return this.httpClient.post(`${ApiConfig.ImageRekognition.croppPhotoBulk}`, request);
    }

    cancelPrehirePhoto(payload: any): Observable<{} | { error: HttpErrorResponse }> {
        return this.httpClient.post(`${ApiConfig.BadgeRequests.cancel}?${generateParams(payload)}`, null)
        .pipe(
            map(() => of({})),
            catchError(error => of({ error }))
        );
    }
}
